// ============================================================
// useUpdateStudent Hook
// ============================================================

import { useState } from 'react';
import useStudentStore from '@/store/studentStore';
import { useSchool } from './useSchool';

export function useUpdateStudent() {
  const { schoolId } = useSchool();
  const updateStudent = useStudentStore((s) => s.updateStudent);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = async (studentId, data) => {
    setLoading(true);
    setError(null);
    try {
      const res = await updateStudent(schoolId, studentId, data);
      setLoading(false);
      return res;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      throw err;
    }
  };

  return { mutate, loading, error };
}
